import CasePageMenuIcon from './CasePageMenuIcon'

export default CasePageMenuIcon
